import { inject, observer } from 'mobx-react';
import * as React from 'react';

import { buildStateProvider } from '@shared-ui/provided-state-context';
import { CustomerNotificationLocation } from '@shared-ui/customer-notifications';
import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';
import { LodgingCompare, LodgingCompareStateChunk, PropertyCompareStateManager } from '@shared-ui/retail-lodging-lodging-compare';
import { TripsToastStateChunk, ValidatedInputsState } from '@shared-ui/trips-save-item';

import { UitkSpacing } from 'uitk-react-spacing';

import { CustomerNotifications } from '../../common/customer-notifications';
import { OneKeyBannerToggle } from 'components/common/one-key-banner-toggle';
import { Pagination } from '../pagination/pagination';
import { PropertyListingWrapper } from '../property-listing/property-listing-wrapper';

const StateProvider = buildStateProvider(new ValidatedInputsState(), TripsToastStateChunk, LodgingCompareStateChunk);

export const PropertySearchListings = inject('searchResults')(
  observer(({ searchResults }) => {
    const { propertyListings } = searchResults;

    return (
      <div data-stid="section-results">
        <StateProvider>
          <PropertyCompareStateManager searchResultsProperties={propertyListings || []}>
            <Experiment name="BEX_mweb_PTP_inline_MAD_LSR_main_Gate">
              <ExperimentControl />
              <ExperimentVariant bucket={1}>
                <UitkSpacing margin={{ block: 'two' }}>
                  <div>
                    <CustomerNotifications location={CustomerNotificationLocation.IN_PAGE} />
                  </div>
                </UitkSpacing>
              </ExperimentVariant>
            </Experiment>
            <Experiment name="one_key_lodging_offers">
              <ExperimentControl />
              <ExperimentVariant bucket={1}>
                <OneKeyBannerToggle />
              </ExperimentVariant>
            </Experiment>
            <PropertyListingWrapper />
            <LodgingCompare />
          </PropertyCompareStateManager>
        </StateProvider>
        <Pagination />
      </div>
    );
  })
);
